// Vendors
import React from 'react';
import { useSelector } from 'react-redux';

// Helpers
import { buildUrl } from '../../../lib/utmHelpers';

// Hooks
import { useLanguageSelector } from '../../../hooks/useLanguageSelector';

// Selectors
import { selectUtmParams } from '../../../reducers/auth/authSelectors';

// Components
import Logo from '../../../components/Logo/Logo';
import LanguageSelector from '../../../components/LanguageSelector/LanguageSelector';
import { Trans } from '../../../components/Trans';
import { TxButton, TxButtonMode } from 'texkit-ui';

// Constants
import { texasGovHelpDeskUrl, texasGovHelpDeskUrlEs } from '../../../constants/appUrls';

// Styles
import './saml-error.scss';

const SamlError = () => {
  const { locale, isLanguageMenuOpen, languageWrapperRef, toggleLanguageMenu, handleLanguageSelect } = useLanguageSelector();
  const utmParams = useSelector(selectUtmParams);

  const helpDeskUrl = locale === 'es' ? texasGovHelpDeskUrlEs : texasGovHelpDeskUrl;

  const handleOpenHelpDesk = () => {
    window.open(buildUrl(helpDeskUrl, utmParams), '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="saml-error-page">
      <div className="saml-error-header">
        <div className="saml-error-logo-wrapper">
          <Logo className="saml-error-logo" />
        </div>
        <LanguageSelector
          locale={locale}
          isLanguageMenuOpen={isLanguageMenuOpen}
          languageWrapperRef={languageWrapperRef}
          toggleLanguageMenu={toggleLanguageMenu}
          handleLanguageSelect={handleLanguageSelect}
        />
      </div>

      <div className="saml-error-content">
        <div className="saml-error-card">
          <h1 className="saml-error-title">
            <Trans
              file="auth"
              id="serverErrorTitle"
              fallback="We ran into a problem"
            />
          </h1>

          <p className="saml-error-message">
            <Trans
              file="auth"
              id="serverErrorBody"
              fallback="Please try again. If you continue to experience this issue, please contact the "
            />
            <TxButton
              type="button"
              className="saml-error-helpdesk-link"
              onClick={handleOpenHelpDesk}
            >
              <Trans
                file="auth"
                id="texasGovHelpDesk"
                fallback="Texas.gov Help Desk"
              />
            </TxButton>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SamlError;
